
import { computed, defineComponent, ref } from '@vue/runtime-core'

export default defineComponent({
  props: {
    text: {
      type: String,
      required: true
    },
    cropLength: {
      type: Number,
      default: 100
    }
  },

  setup(props) {
    const isOpen = ref(props.text.length <= props.cropLength)

    const outputText = computed(() => {
      if (isOpen.value) return props.text

      return props.text.substring(0, props.cropLength) + '…'
    })

    return {
      isOpen,
      outputText
    }
  }
})
